"use strict";

const IndcomInventoryFiles = function () {
  const stringKey = "facility-files";
  const headerInformation = "Files";
  var $page;

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var loadListeners = function () {
    Form.initializeAndLoadListeners($page, "indcom-inventory", { isMultiPart: true });
    $page.on("click", ".save-button", saveFileData);
    $page.on("click", ".edit-button", editFile);
    $page.on("click", `[name*="location-type"]`, setLocationRadioClick);
    $page.on("click", ".new-file", insertNewFile);
    $page.on("click", ".delete-button", deleteFileButtonClick);
    $page.on("click", ".delete-editing-button", deleteEditingFileButtonClick);
    $page.on("click", ".save-initial-button", saveInitialFileData);
  };

  var unloadListeners = function () {
    $page.off("click", ".save-button");
    $page.off("click", ".edit-button");
    $page.off("click", `[name*="location-type"]`);
    $page.off("click", ".new-file");
    $page.off("click", ".delete-button");
    $page.off("click", ".delete-editing-button");
    $page.off("click", ".save-initial-button", saveInitialFileData);
  };

  var render = function (options = {}) {
    const facility = InventoryModal.getAllData("indcom-inventory");
    const props = getProps(facility);
    renderFilesHtml(props);
    initializeExistingFiles(props);
    loadListeners();
    setInitialState(props, options);
  };

  var getProps = function (facility) {
    return {
      facilityFiles: prepareFiles(facility),
      fileTypes: IndcomInventoryConstants.getFileTypeOptions(),
      uploadLocation: IndcomInventoryConstants.uploadLocationOptions,
    };
  };

  var prepareFiles = function (props) {
    return props.facilityFiles
      .filter((file) => !file.deleted)
      .map((file) => ({
        ...file,
        displayApprovalDate: getDisplayDateFromIsoDate(file),
        displayType: getDisplayFileType(file.type),
      }))
      .sort((a, b) => a.id - b.id);
  };

  var setInitialState = function (props, options) {
    const numFiles = ((props || {}).facilityFiles || []).length;
    if (options.editFile) {
      editFileById(options.editFile);
    } else if (numFiles === 0 || options.newFile) {
      $page.find(".new-file").hide();
      stageNewFile();
      const index = $page.find(".file-display").first().data("index");
      $page.on(
        "input drop",
        `[name*="facilityFiles[${index}]"], [data-name*="facilityFiles[${index}]"]`,
        stageInitialFileObj,
      );
    }
  };

  var insertNewFile = function () {
    const { html, newFile, currentFilesLength } = createFileHtml();
    Form.manuallySetFormDataField(
      "indcom-inventory",
      ["facilityFiles", currentFilesLength],
      newFile,
    );
    $page.find(".facility-files").prepend(html);
    toggleEditSaveButtonsDisabled(true);
    initializeAdditionalFormFields(newFile);
  };

  var stageNewFile = function () {
    const { html, newFile, currentFilesLength } = createFileHtml(true);
    $page.on("input", `[name*="facilityFiles[${currentFilesLength}]"]`, createFormFileEntry);
    $page.find(".facility-files").prepend(html);
    toggleEditSaveButtonsDisabled(true);
    initializeAdditionalFormFields(newFile);
  };

  var createFormFileEntry = function (e) {
    const filePosition = $(e.currentTarget).parents(".file-display").data("index");
    stageInitialFileObj(e);
    removeInitialInputListener(filePosition);
  };

  var createFileHtml = function (initialFile = false) {
    const fileTypes = IndcomInventoryConstants.getFileTypeOptions();
    var uploadLocation = IndcomInventoryConstants.uploadLocationOptions;
    uploadLocation = uploadLocation.find((location) => {
      return location.value === "external-url";
    });

    const newId = Date.now();
    const newFile = {
      id: newId,
      type: fileTypes[0].value,
      locationType: uploadLocation.value,
      displayLocationType: uploadLocation.name,
      approvalDate: DateTime.getTodayIso(),
    };
    const currentFilesLength = getCurrentFilesLength();

    return {
      html: nunjucks.render("modals/indcomInventory/indcomInventoryNewFile.njk", {
        fileTypes: fileTypes,
        file: newFile,
        uploadLocation: IndcomInventoryConstants.uploadLocationOptions,
        index: currentFilesLength,
        initialFile: initialFile,
      }),
      newFile: newFile,
      currentFilesLength: currentFilesLength,
    };
  };

  var getCurrentFilesLength = function () {
    const data = InventoryModal.getAllData("indcom-inventory");
    return (data.facilityFiles || []).length;
  };

  var stageInitialFileObj = function (e) {
    const $firstFile = $page.find(".facility-files .file").first();
    const fileId = $firstFile.data("id");
    const filePosition = $(e.currentTarget).parents(".file").find(".file-display").data("index");
    if (!getFileById(fileId)) {
      const type = $firstFile.find(`[name="facilityFiles[${filePosition}][type]"]`).val();
      const locationType = $firstFile
        .find(`[name="facilityFiles[${filePosition}][location-type]"] option:selected`)
        .val();
      const approvalDate = $firstFile
        .find(`[name="facilityFiles[${filePosition}][approval-date]"]`)
        .val();
      Form.manuallySetFormDataField(
        "indcom-inventory",
        ["facilityFiles", filePosition, "id"],
        fileId,
      );
      Form.manuallySetFormDataField(
        "indcom-inventory",
        ["facilityFiles", filePosition, "locationType"],
        locationType,
      );
      Form.manuallySetFormDataField(
        "indcom-inventory",
        ["facilityFiles", filePosition, "type"],
        type,
      );
      Form.manuallySetFormDataField(
        "indcom-inventory",
        ["facilityFiles", filePosition, "approvalDate"],
        DateTime.truncateMilliseconds(approvalDate),
      );
    }

    $page.off(
      "input drop",
      `[name*="facilityFiles[${filePosition}]"], [data-name*="facilityFiles[${filePosition}]"] `,
      stageInitialFileObj,
    );
  };

  var initializeAdditionalFormFields = function (file) {
    const displayDate = getIsoDateFromDisplayDate(file);
    initializeDatePicker(displayDate);
    initializeDropzone(file, false);
    showInputByLocationType(file.locationType);
  };

  var initializeDatePicker = function (date) {
    Form.initializeDatePickers($page, "indcom-inventory");
    if (date) {
      DateTimePicker.setDateOnElement($page.find("[name*=approval-date]").assertLength(1), date);
    }
  };

  var initializeExistingFiles = function (facility) {
    facility.facilityFiles.forEach((existingFile) => {
      initializeDropzone(existingFile, true);
    });
  };

  var initializeDropzone = function (facilityFile, readOnly) {
    const $parent = $page.find(`[data-id=${facilityFile.id}]`);
    const dropzoneName = $parent.find(".drop-zone").attr("name");
    let newFile = [];
    let existingFile = [];
    if ($.isArray(facilityFile.fileUploadLocation)) {
      newFile = facilityFile.fileUploadLocation;
    } else if (facilityFile.uploadedFilename) {
      existingFile = [facilityFile.uploadedFilename];
    }
    const dropzone = Form.initializeDropzone("indcom-inventory", $parent, {
      newFiles: newFile,
      existingFiles: existingFile,
      maxNumberFiles: 1,
      readOnly,
    });

    configureDropzoneHandlers(facilityFile.id, dropzoneName, dropzone);
  };

  var configureDropzoneHandlers = function (facilityId, dropzoneName, dropzone) {
    dropzone.setDownloadHandler(() => ApiCalls.downloadFacilityFile(facilityId));
    dropzone.setRemoveExistingCallback((file) => {
      removeFileFromForm(dropzoneName, file);
    });
  };

  var setLocationRadioClick = function (e) {
    const value = $(e.currentTarget).val();
    showInputByLocationType(value);
  };

  var editFile = function (e) {
    const $file = $(e.currentTarget);
    const fileId = $file.closest(".file").data("id");
    editFileById(fileId);
  };

  var editFileById = function (fileId) {
    const fileInfo = getFileById(fileId);
    const options = getFileTypeOptionsWithFile(fileInfo);

    const html = nunjucks.render("modals/indcomInventory/indcomInventoryModifyFile.njk", {
      fileTypes: options,
      uploadLocation: IndcomInventoryConstants.uploadLocationOptions,
      file: fileInfo,
      index: getFileIndexById(fileId),
    });
    $(`.file[data-id=${fileId}]`).html(html);
    toggleEditSaveButtonsDisabled(true);
    initializeAdditionalFormFields(fileInfo);
  };

  var getFileTypeOptionsWithFile = function (fileInfo) {
    const options = Array.from(IndcomInventoryConstants.getFileTypeOptions());

    if (
      !options.some(function (option) {
        return option.value === fileInfo.type;
      })
    ) {
      options.unshift(getFileType(fileInfo.type));
    }

    return options;
  };

  var saveInitialFileData = function (e) {
    stageInitialFileObj(e);
    saveFileData(e);
  };

  var saveFileData = function (e) {
    const $file = $(e.currentTarget);
    const fileId = $file.closest(".file").data("id");
    let file = getFileById(fileId);
    const type = IndcomInventoryConstants.uploadLocationOptions.find((option) => {
      return option.value === file.locationType;
    });
    if (type === undefined) {
      throw new Error(`File type ${file.locationType} does not exist.`);
    }
    file.displayLocationType = type.name;
    file = addAbsoluteUrlsToFiles([file])[0];
    const html = nunjucks.render("modals/indcomInventory/indcomInventoryExistingFile.njk", {
      file: {
        ...file,
        displayApprovalDate: getDisplayDateFromIsoDate(file),
        displayType: getDisplayFileType(file.type),
      },
    });
    removeInitialInputListener();
    toggleEditSaveButtonsDisabled(false);
    $file.closest("section").html(html);
    initializeDropzone(file, true);
  };

  var deleteFileButtonClick = function (e) {
    showDeleteFileModal(e, false);
  };

  var deleteEditingFileButtonClick = function (e) {
    showDeleteFileModal(e, true);
  };

  var showDeleteFileModal = function (e, editingFile) {
    const $file = $(e.currentTarget).closest(".file");
    const fileId = $file.data("id");
    const displayFileType = getDisplayFileTypeById(fileId);
    if (displayFileType) {
      const deleteCallback = function () {
        deleteFile(fileId);
        if (editingFile === true) {
          toggleEditSaveButtonsDisabled(false);
        }
      };

      MessageModal.showConfirmWarningModal(
        `You have selected to delete this ${displayFileType}. To permanently delete this file from your 2NFORM data, click Delete. To keep the record, click Cancel.`,
        deleteCallback,
        "Cancel",
        "Delete",
      );
    } else {
      removeInitialInputListener();
      $(`[data-id="${fileId}"]`).remove();
      toggleEditSaveButtonsDisabled(false);
    }
  };

  var deleteFile = function (fileId) {
    const fileIndex = getFileIndexById(fileId);
    const existingFileIds = (
      IndcomInventoryModalController.getExistingData("facilityFiles") || []
    ).map((file) => {
      return file.id;
    });

    if (existingFileIds.includes(fileId)) {
      Form.manuallySetFormDataField("indcom-inventory", ["facilityFiles", fileIndex], {
        deleted: true,
        id: fileId,
      });
    } else {
      Form.manuallyUnsetField("indcom-inventory", ["facilityFiles", fileIndex]);
    }
    $(`[data-id="${fileId}"]`).remove();
  };

  var toggleEditSaveButtonsDisabled = function (disabled) {
    if (disabled === false) {
      $page.find(".new-file").show();
    }
    $(".edit-button, .new-file").prop("disabled", disabled);
  };

  var renderFilesHtml = function (facility) {
    facility.facilityFiles = addAbsoluteUrlsToFiles(facility.facilityFiles || []);
    const html = nunjucks.render("modals/indcomInventory/indcomInventoryFiles.njk", facility);
    IndcomInventoryModalController.renderPageContent(html);
    $page = $("#inventory-modal .modal-dynamic-content").assertLength(1);
  };

  function addAbsoluteUrlsToFiles(files) {
    return files.map((file) => {
      const makeAbsolute = file.externalUrl && !/^(https?:)?\/\/.*$/.test(file.externalUrl);
      file.absoluteUrl = makeAbsolute ? "//" + file.externalUrl : file.externalUrl;
      return file;
    });
  }

  var getFileById = function (fileId) {
    const data = InventoryModal.getAllData("indcom-inventory");
    return data.facilityFiles.find((file) => {
      return file?.id === fileId;
    });
  };

  var getFileIndexById = function (fileId) {
    const data = InventoryModal.getAllData("indcom-inventory");
    if (data.facilityFiles) {
      return data.facilityFiles.findIndex((file) => {
        return fileId === (file || {}).id;
      });
    }
  };

  var getDisplayFileTypeById = function (fileId) {
    const fileIndex = getFileIndexById(fileId);
    const fileType = InventoryModal.getLatestData("indcom-inventory", [
      "facilityFiles",
      fileIndex,
      "type",
    ]);
    return fileType === undefined ? undefined : getDisplayFileType(fileType);
  };

  var getDisplayDateFromIsoDate = function (file) {
    if (file.approvalDate !== undefined) {
      return DateTime.formatIsoString(file.approvalDate);
    } else {
      return file.displayApprovalDate;
    }
  };

  var getIsoDateFromDisplayDate = function (file) {
    if (file.approvalDate === undefined) {
      return DateTime.parseDateToIso(file.displayApprovalDate);
    } else return file.approvalDate;
  };

  var getDisplayFileType = function (fileValue) {
    return getFileType(fileValue).displayName;
  };

  var getFileType = function (fileValue) {
    return IndcomInventoryConstants.getFileTypeOptions().find((options) => {
      return options.value === fileValue;
    });
  };

  var cleanUp = function () {
    unloadListeners();
    $page.empty();
    return true;
  };

  var validate = function () {
    return true;
  };

  var showInputByLocationType = function (locationType) {
    $page.find(".file-text-description").toggle(locationType === "location");
    $page.find(".file-drop-zone").toggle(locationType === "upload");
    $page.find(".file-external-url").toggle(locationType === "external-url");
  };

  const removeFileFromForm = function (dropzoneName, file) {
    const pathParts = Form.getPathPartsFromName(dropzoneName);
    Form.manuallySetFormDataField("indcom-inventory", pathParts, "");
  };

  var removeInitialInputListener = function (length) {
    const currentFilesLength = length || getCurrentFilesLength();
    $page.off("input", `[name*="facilityFiles[${currentFilesLength}]"]`, createFormFileEntry);
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    cleanUp,
    validate,
    deleteFile,
  };
};

module.exports = IndcomInventoryFiles();

const IndcomInventoryModalController = require("./indcomInventoryModalController");
const InventoryModal = require("../general/inventoryModal");
const IndcomInventoryConstants = require("./indcomInventoryConstants");
const Form = require("../general/form");
const DateTime = require("../dateTime");
const DateTimePicker = require("../general/dateTimePicker");
const MessageModal = require("../modals/messageModal");
const ApiCalls = require("../apiCalls");
